export default "__VITE_ASSET__BWE1Hxny__"